import React, { type AbstractComponent } from 'react'
import { InformationFrameStyle, AnimatedFade } from './animations'
import classnames from 'classnames'
import { InfiniteMarquee } from './InfiniteMarquee'

type InformationFrameProps = {
	className?: string,
	contentClassName?: string,
	hideDecal?: boolean,
	children: React$Node,
	headline?: string | null,
	isExiting: boolean,
	onFinishExit: () => void,
}
/**
 * A frame for displaying information about a literacy event.
 */
export const InformationFrame: AbstractComponent<
	InformationFrameProps,
	?HTMLDivElement
> = React.forwardRef(function _InformationFrame(
	{
		className,
		children,
		headline,
		isExiting,
		onFinishExit,
		hideDecal,
		contentClassName,
	}: InformationFrameProps,
	ref
): React$Node {
	const id = React.useId()
	return (
		<InformationFrameStyle
			data-testid="information-frame"
			ref={ref}
			className={className}
			$exit={isExiting}
			id={id}
			onAnimationEnd={e => {
				if (e.target.id === id) {
					isExiting && onFinishExit()
				}
			}}>
			<AnimatedFade $exit={isExiting}>
				{headline && <InfiniteMarquee title={headline}></InfiniteMarquee>}
				<div
					className={classnames(
						'rounded pb-6 flex-1 overflow-y-hidden bg-gradient-to-b  from-[#ddddf6] to-[#c4feff] border-4 border-game-primary-green',
						contentClassName
					)}>
					{children}
				</div>
			</AnimatedFade>
		</InformationFrameStyle>
	)
})
